import API, { setAuthToken } from "@core/api/api";

export const getSettings = async () => {
  if (!localStorage.getItem("token")) {
    return null;
  }
  setAuthToken(localStorage.getItem("token"));
  const response = await API.get(`/settings`);
  return response.data;
};

export const updateSetting = async (values) => {
  const response = await API.put(`/settings`, values);
  return response.data;
};

export const getPricing = async (params) => {
  const response = await API.get(`/settings/pricing?${params}`);
  return response.data;
};

export const getFiles = async (params) => {
  const response = await API.get(`/settings/files`);
  return response.data;
};
